import { render, staticRenderFns } from "./qualificationTest.vue?vue&type=template&id=494f5e5f&scoped=true"
import script from "./qualificationTest.vue?vue&type=script&lang=js"
export * from "./qualificationTest.vue?vue&type=script&lang=js"
import style0 from "./qualificationTest.vue?vue&type=style&index=0&id=494f5e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f5e5f",
  null
  
)

export default component.exports